import client from './main-client';

export const blanketsApi = (params) => client().get(`/blankets/?userId=${params.userId}&$limit=null&active=true`);

export const addBlanketApi = (data) => client().post('/blankets', data);

export const updateBlanketApi = (data) => client().put(`/blankets/${data._id}`, data);
